import React, { ReactNode, useEffect } from "react";
import { Provider } from "react-redux";
import spacesStore, { SpacesContext } from "./spacesStore";
import { requestListIceServers } from "./msgs/ice/iceMsgSender";
import { requestRoomosListConfig } from "./msgs/roomos/roomosMsgSender";
import "./msgs/roomos/roomosMsgReciever";
interface IProps {
    children: ReactNode;
}

function SpacesProvider(props: IProps) {
    useEffect(() => {
        requestListIceServers();
        requestRoomosListConfig();
    }, []);

    return (
        <Provider store={spacesStore} context={SpacesContext}>
            {props.children}
        </Provider>
    );
}

export default SpacesProvider;
